import React from "react";
import { Box, Grid, Paper, Stack, Typography, Chip } from "@mui/material";
import { touchscreen2 } from "../../../assets"; // optional if you have a product image

const ATGProSection = () => {
  return (
    <Box component="section" id="atg-pro" sx={{ py: 10 }}>
      <Grid container spacing={6} alignItems="center">
        <Grid item xs={12} md={6}>
          <Stack spacing={2}>
            <Typography variant="h2" sx={{ color: "#fff", fontWeight: 900, fontFamily: "Poppins, sans-serif" }}>
              ATG Pro
            </Typography>

            <Stack direction="row" spacing={1} flexWrap="wrap">
              <Chip label='7" HD Touchscreen' color="primary" sx={{ fontWeight: 800 }} />
              <Chip label="CPU + Networking Upgrade" sx={{ bgcolor: "rgba(59,130,246,0.18)", color: "#fff", fontWeight: 800 }} />
              <Chip label="Remote Monitoring" sx={{ bgcolor: "rgba(34,197,94,0.18)", color: "#fff", fontWeight: 800 }} />
            </Stack>

            <Typography variant="h3" sx={{ color: "rgba(226,232,240,0.8)", maxWidth: 560 }}>
              A retrofit kit that modernizes legacy ATGs with a clean touchscreen interface, a faster compute core,
              and reliable cloud connectivity. Get real-time tank visibility, alarms, and reporting without replacing your console.
            </Typography>

            <Typography variant="h4" sx={{ color: "rgba(226,232,240,0.7)", maxWidth: 560 }}>
              Below are live UI demos of the ATG Pro console experience: tank dashboard, alarms, and inventory charts.
            </Typography>
          </Stack>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper
            elevation={10}
            sx={{
              borderRadius: 4,
              overflow: "hidden",
              bgcolor: "rgba(15,23,42,0.85)",
              border: "1px solid rgba(148,163,184,0.25)",
            }}
          >
            <Box
              component="img"
              src={touchscreen2}
              alt="ATG Pro Touchscreen"
              sx={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ATGProSection;
